import {
    CoachingRole,
    InteractionScoreExtraResult,
} from '../../coaching-base/general';
import { Row } from '../../coaching-observation/experimental.grid';

import { ObservationFormValue } from './observations.commitment.form';

export enum ColumnID {
    OBSERVER = 'observer',
    DATE = 'date',
    INTERACTION_COUNT = 'interaction_count',
    NOTE_COUNT = 'note_count',
    PROFICIENCY_DELIVERED = 'proficiency_delivered',
    CONSISTENCY_DELIVERED = 'consistency_delivered',
    CONFIDENCE_DELIVERED = 'confidence_delivered',
    ACTION = 'action',
}

export enum TemplateID {
    HEADER = 'header',
    CONTENT = 'content',
}

export interface ColumnContext {
    templateId: TemplateID;
}

export interface RowContext {
    e: ObservationFormValue;
    observer: string;
    performerId: number;
    interactionsCount: number;
    notesCount: number;
    opportunityToDemonstrate: number;
    willingnessToTry: number;
    proficiencyDelivered: number;
}

export interface CellContext {
    templateId: TemplateID;
}

export function makeRows(
    model: ObservationFormValue[],
): Array<Row<RowContext, CellContext>> {
    const height = 45;

    return model.map<Row<RowContext, CellContext>>((e) => {
        const observer = e.eventParticipants.find(
            (ee) => ee.coachingRoleId === CoachingRole.OBSERVER,
        );
        const performer = e.eventParticipants.find(
            (ee) => ee.coachingRoleId === CoachingRole.PERFORMER,
        );

        const interactionsCount = !e.focusContainers
            ? 0
            : e.focusContainers.reduce((p, c) => {
                  if (c.interactions) {
                      p += c.interactions.length;
                  }
                  return p;
              }, 0);
        const notesCount = !e.focusContainers
            ? 0
            : e.focusContainers.reduce((p, c) => {
                  if (c.interactions) {
                      p += c.interactions.reduce((pp, cc) => {
                          if (cc.notes) {
                              pp += cc.notes.length;
                          }
                          return pp;
                      }, 0);
                  }
                  return p;
              }, 0);

        // there should at most be one focus container in this context anyway
        let score: InteractionScoreExtraResult;
        if (e.focusContainers && e.focusContainers.length !== 0) {
            score = e.focusContainers[0].score;
        }

        return {
            id: Math.random().toString(),
            height,
            ctx: {
                e,
                observer: observer
                    ? `${observer.firstName} ${observer.lastName}`
                    : null,
                performerId: performer ? performer.userId : null,
                interactionsCount,
                notesCount,
                opportunityToDemonstrate: score
                    ? score.opportunityToDemonstrate
                    : null,
                willingnessToTry: score ? score.willingnessToTry : null,
                proficiencyDelivered: score ? score.proficiencyDelivered : null,
            },
            cells: [
                {
                    columnId: ColumnID.OBSERVER,
                    height,
                    ctx: { templateId: TemplateID.CONTENT },
                },
                {
                    columnId: ColumnID.DATE,
                    height,
                    ctx: { templateId: TemplateID.CONTENT },
                },
                {
                    columnId: ColumnID.INTERACTION_COUNT,
                    height,
                    ctx: { templateId: TemplateID.CONTENT },
                },
                {
                    columnId: ColumnID.NOTE_COUNT,
                    height,
                    ctx: { templateId: TemplateID.CONTENT },
                },
                {
                    columnId: ColumnID.PROFICIENCY_DELIVERED,
                    height,
                    ctx: { templateId: TemplateID.CONTENT },
                },
                {
                    columnId: ColumnID.CONSISTENCY_DELIVERED,
                    height,
                    ctx: { templateId: TemplateID.CONTENT },
                },
                {
                    columnId: ColumnID.CONFIDENCE_DELIVERED,
                    height,
                    ctx: { templateId: TemplateID.CONTENT },
                },
                {
                    columnId: ColumnID.ACTION,
                    height,
                    ctx: { templateId: TemplateID.CONTENT },
                },
            ],
        };
    });
}
